import React from "react";
import AlertDialog from "../../components/AlertDialog";
import Button from "./../../components/Button";
import { useHistory } from "react-router-dom";
import styles from "./HelpRequestForm.module.scss";
import ClassNames from "classnames";

export const CancelModal = ({
  isCancelModalOpen,
  setIsCancelModalOpen = () => {},
}) => {
  const history = useHistory();
  return (
    <div>
      <AlertDialog
        maxWidth="xs"
        open={isCancelModalOpen}
        onClose={() => {
          setIsCancelModalOpen(false);
        }}
        title={
          <div className={styles.modalTitle}>{"Cancel your request?"}</div>
        }
        body={
          <div className={ClassNames(styles.introText, styles.textLeft)}>
            {`Remember that any response already added to this form won't be saved.`}
          </div>
        }
        footer={
          <div className={styles.modalFooter}>
            <div
              className={styles.returnToFromBtn}
              onClick={() => {
                setIsCancelModalOpen(false);
              }}
            >
              {"Return to form"}
            </div>
            <Button
              className={styles.cancelRequestBtn}
              onClick={() => {
                history.replace("/");
              }}
            >
              {"Yes, cancel request"}
            </Button>
          </div>
        }
      />
    </div>
  );
};
